/**
 * Get todays date, without the time part
 * @public
 *
 * @returns The current date at 00:00:00.000 UTC
 *
 * @example
 * ```ts
 * const today = getTodayDate();
 * console.log(today);
 * // -> 2020-05-12T00:00:00.000Z
 * ```
 */
function getTodayDate(): Date {
  const today: Date = new Date();

  return new Date(today.getFullYear(), today.getMonth(), today.getDate());
}

export { getTodayDate };
